const o = (r) => {
  try {
    const t = new URL(r);
    return t.protocol === "http:" || t.protocol === "https:";
  } catch {
    return !1;
  }
};
export {
  o as isValidUrl
};
